/* aa-variant-dropdown.js — PDP variant dropdown.
   When the shopper picks an option, mark the trigger as selected so its displayed value
   turns from grey ("Select <name>" placeholder) to black. global.js updates the text but
   adds no state class, so we add one here. (The pick itself — checking the underlying radio —
   is handled by Madrid's variant-radios.js, which changes the variant + URL.) */
(function () {
  'use strict';
  if (window.__aaVariantDropdown) return;
  window.__aaVariantDropdown = true;

  document.addEventListener('click', function (e) {
    var li = e.target.closest('.product-parameters .dropdown-select ul li');
    if (!li) return;
    var input = li.querySelector('input');
    if (input && input.classList.contains('disabled')) return; // sold-out option: no change
    var dd = li.closest('.product-form__controls--dropdown');
    var label = dd && dd.querySelector('.select-label');
    if (label) label.classList.add('aa-vselected');
  });
})();
